<template>
	<page class="order-submit">
		<module>
            <div class="box">
			<div class="client-info flex-center">
                <div v-if="memberInfo">
                    <c-image  :src="memberInfo.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                </div>
				<div v-else class="icon flex-center">
                    <i class="tf tf-user"></i>
                </div>
                <div v-if="memberInfo" class="flex-grow">
                    <p class="name">昵称：{{memberInfo.nick_name}}</p>
					<p class="code">
                        手机号：{{memberInfo.user_manage_mobilephone}} &nbsp;&nbsp;&nbsp;&nbsp;
                        <span v-if="memberInfo.login_name">  登录名：{{memberInfo.login_name}}</span>
                    </p>
				</div>
				<p v-else class="name flex-grow" style="color: #f55;">请先选择客户再下单</p>
				<c-button size="m" color="black" hollow @click="$refs.memberSelector.open()">{{memberInfo ? '修改客户' : '选择客户'}}</c-button>
			</div>
			
			<div v-if="memberInfo">
				<div class="handle flex-between-center">
					<div class="flex-baseline">
						<div class="title">货品清单</div>
						<p class="tip">注：代客下单仅支持平台自营商品，可直接输入产品SKU编码、产品货号、名称模糊搜索添加商品</p>
					</div>
					<div>
						<c-button color="gray" hollow icon="excel" @click="$refs.import.open()">导入下单</c-button>
						<c-button @click="addProduct('productList')">添加商品</c-button>
					</div>
				</div>
				
				<c-table ref="productList" :value="productList" height="auto" border>
					<c-table-column
						label="SKU编码"
						width="220"
					>
						<template v-slot="item">
							<c-input v-model="item.data.product_sku_code" width="100%" height="30" search @search="projectSearch(arguments[0], arguments[1], arguments[2], 'product_sku_code')" @option="setProduct($event, 'productList', item)"></c-input>
						</template>
					</c-table-column>

					<c-table-column
						label="商品货号"
						width="220"
					>
						<template v-slot="item">
							<c-input v-model="item.data.product_itemnumber" width="100%" height="30" search @search="projectSearch(arguments[0], arguments[1], arguments[2], 'product_itemnumber')" @option="setProduct($event, 'productList', item)"></c-input>
						</template>
					</c-table-column>

					<c-table-column
						label="商品名称"
						width="220"
					>
						<template v-slot="item">
							<c-input v-model="item.data.product_name" width="100%" height="30" search @search="projectSearch(arguments[0], arguments[1], arguments[2], 'product_name')" @option="setProduct($event, 'productList', item)"></c-input>
						</template>
					</c-table-column>

					<c-table-column
						label="规格信息"
						width="150"
					>
						<template v-slot="{data}">
							<div class="flex-center-cross">
								<c-image v-if="data.product_img_url" size="40" :src="data.product_img_url" preview style="margin-right: 10px;"></c-image>
								{{data.product_sku_spec}}
							</div>
						</template>
					</c-table-column>

					<c-table-column
						label="单价"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.product_price">￥{{data.product_price}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="数量"
						width="100"
					>
						<template v-slot="{data}">
							<c-input v-model="data.count" type="number" width="100%" height="30" @blur="updateProductTotal"></c-input>
						</template>
					</c-table-column>

					<c-table-column
						label="小计"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.product_price">￥{{((data.count || 0) * parseFloat(data.product_price)).toFixed(2)}}</span>
						</template>
					</c-table-column>

					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="80"
					>
						<template v-slot="item">
							<c-table-button v-if="item.data.product_sku" @click="removeProduct(item)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>

				<div class="handle flex-between-center">
					<div class="title">赠品区</div>
					<div>
						<c-button color="black" @click="addProduct('giftList')">添加赠品</c-button>
					</div>
				</div>

				<c-table ref="giftList" :value="giftList" height="auto" border>
					<c-table-column
						label="产品代码"
						width="220"
					>
						<template v-slot="item">
							<c-input v-model="item.data.product_sku_code" width="100%" height="30" search @search="projectSearch(arguments[0], arguments[1], arguments[2], 'product_sku_code')" @option="setProduct($event, 'giftList', item)"></c-input>
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品名称"
						width="220"
					>
						<template v-slot="item">
							<c-input v-model="item.data.product_name" width="100%" height="30" search @search="projectSearch(arguments[0], arguments[1], arguments[2], 'product_name')" @option="setProduct($event, 'giftList', item)"></c-input>
						</template>
					</c-table-column>
					
					<c-table-column
						label="规格信息"
						width="150"
					>
						<template v-slot="{data}">
							<div class="flex-center-cross">
								<c-image v-if="data.product_img_url" size="40" :src="data.product_img_url" preview style="margin-right: 10px;"></c-image>
								{{data.product_sku_spec}}
							</div>
						</template>
					</c-table-column>
					
					<c-table-column
						label="单价"
						name="product_price"
						width="100"
					>
						<template v-slot="{data}">
							<p v-if="data.product_price">
								<span>￥0.00</span>
								<del style="margin-left: 5px; color: #999;">￥{{data.product_price}}</del>
							</p>
						</template>
					</c-table-column>
					
					<c-table-column
						label="赠送数量"
						width="200"
					>
						<template v-slot="{data}">
							<c-input v-model="data.count" type="number" width="100%" height="30" @blur="updateGiftTotal"></c-input>
						</template>
					</c-table-column>
					
					<c-table-column
						type="button"
						fixed="right"
						label="操作"
						width="80"
					>
						<template v-slot="item">
							<c-table-button v-if="item.data.product_sku" @click="removeGift(item)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
				
			</div>
			
			<div v-else class="client-empty">
				<div><i class="tf">&#xe7da;</i></div>
				<p>下单前请先在右上方选择客户</p>
			</div>
		</div>
        </module>
        <!--积分-->
        <module v-if="memberInfo.points && memberInfo.points > 0">
            <div class="box flex">
                <div class="flex-grow">
                    <div class="handle flex-center-cross">
                        <div class="title">积分</div>
						<div class="inline flex-center">
							<c-radio-group v-model="isUsePoints">
								<c-radio value="1">积分抵扣</c-radio>
								<c-radio value="0">不抵扣</c-radio>
							</c-radio-group>
							<p v-if="isUsePoints == 1 && pointsCredit.points > 0" class="tip"><span>减￥{{this.pointsCredit.points_discount_money}}</span> (此次抵扣消耗{{this.pointsCredit.points}}积分，共{{memberInfo.points}}积分)</p>
						</div>
                    </div>
                </div>
            </div>
        </module>
        <!--优惠券-->
        <module v-if="memberInfo && userCouponList.length">
            <div class="box flex">
                <div class="flex-grow">
                    <div class="handle flex-center-cross">
                        <div class="title">优惠券</div>
						<div class="inline">
							<c-radio-group v-model="isUseCoupon">
								<c-radio value="1">使用优惠</c-radio>
								<c-radio value="0">不使用优惠</c-radio>
							</c-radio-group>
						</div>
                    </div>
					<div v-show="isUseCoupon == 1" class="coupon-list flex-wrap">
						<coupon v-for="(item, i) in userCouponList" :key="i" class="coupon-item" :data="item" :disabled="item.disabled" :current="currentCoupon.id == item.id" @click="currentCoupon = item"></coupon>
					</div>
                </div>
            </div>
        </module>
        <!--发票+收货地址-->
		<module v-if="memberInfo">
			<div class="box flex">
				<div class="flex-grow" v-if="systemConfig.order_invoice_enabled == 'ON'" style="margin-right: 60px;">
					<div class="handle flex-between-center">
						<div class="title">开票信息</div>
						<div>
							<c-radio-group v-show="memberInfo.pay_type != 1" v-model="invoiceState">
								<c-radio value="1">开票</c-radio>
								<c-radio value="0">不开票</c-radio>
							</c-radio-group>
						</div>
					</div>
					<div class="other">
						<p v-if="invoiceState == 0" class="empty flex-center">此订单不开发票</p>
						<p v-else-if="!currentInvoice" class="empty flex-center">
							<a @click="$refs.invoiceManage.open(memberInfo)"><i class="tf tf-plus"></i>管理发票信息</a>
						</p>
						<div v-else>
							<div class="content">
								<p class="item">
									<label>发票类型：</label>
									<span v-if="currentInvoice.invoice_type == 1">普通发票</span>
									<span v-if="currentInvoice.invoice_type == 2">增值税专用发票6%</span>
									<span v-if="currentInvoice.invoice_type == 3">增值税专用发票13%</span>
								</p>
								<p class="item">
									<label>发票抬头：</label>
									<span>{{currentInvoice.invoice_title}}</span>
								</p>
								<p class="item">
									<label>纳税人识别号：</label>
									<span>{{currentInvoice.tax_number}}</span>
								</p>
								<p class="item" v-if="currentInvoice.invoice_type != 1">
									<label>开户行：</label>
									<span>{{currentInvoice.bank_name}}</span>
								</p>
								<p class="item" v-if="currentInvoice.invoice_type != 1">
									<label>银行账号：</label>
									<span>{{currentInvoice.bank_account}}</span>
								</p>
								<p class="item" v-if="currentInvoice.invoice_type != 1">
									<label>开票地址：</label>
									<span>{{currentInvoice.kp_address}}</span>
								</p>
								<p class="item" v-if="currentInvoice.invoice_type != 1">
									<label>开票电话：</label>
									<span>{{currentInvoice.kp_phone}}</span>
								</p>
								<p class="item">
									<label>收票人信息：</label>
									<span>{{currentInvoice.contact_name || '--'}}<span v-if="currentInvoice.contact_phone">（电话：{{currentInvoice.contact_phone}}）</span><span v-if="memberInvoiceAddress.trim()">（地址：{{memberInvoiceAddress}}）</span></span>
								</p>
								<p class="item">
									<label>电子邮箱：</label>
									<span>{{currentInvoice.email || '--'}}</span>
								</p>
							</div>
							
							<div class="flex-end">
								<a @click="$refs.invoiceManage.open(memberInfo)"><i class="tf tf-edit"></i>更换</a>
							</div>
						</div>
					</div>
				</div>

				<div class="flex-grow">
					<div class="handle flex-between-center">
						<div class="title">收货地址</div>
					</div>
					<div class="other">
						<p v-if="!currentAddress" class="empty flex-center">
							<a @click="$refs.addressManage.open(memberInfo)"><i class="tf tf-plus"></i>管理收货地址</a>
						</p>
						<div v-else>
							<div class="content">
								<p class="item">
									<label>收货人：</label>
									<span>{{currentAddress.receiving_name}}</span>
								</p>
								<p class="item">
									<label>联系电话：</label>
									<span>{{currentAddress.receiving_phone}}</span>
								</p>
								<p class="item">
									<label>收货地址：</label>
									<span>{{currentAddress.province_name}}{{currentAddress.city_name}}{{currentAddress.county_name}}{{currentAddress.receiving_address_details}}</span>
								</p>
								<p class="item">
									<label>周末收货：</label>
									<span>{{currentAddress.is_weeked_receive == 1 ? '是' : '否'}}</span>
								</p>
								<p class="item">
									<label>预约与否：</label>
									<span>{{currentAddress.is_reservation == 1 ? '需要预约' : '不需要预约'}} <span v-if="currentAddress.is_reservation == 1">（预约电话：{{currentAddress.reservation_tel}}）</span></span>
								</p>
							</div>

							<div class="flex-end">
								<a @click="$refs.addressManage.open(memberInfo)"><i class="tf tf-edit"></i>更换</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</module>
        <!--订单代发信息,平台支持代发才展示该内容-->
        <module v-if="memberInfo && systemConfig.agent_delivery_enabled == 'ON'">
<!--        <module v-if="memberInfo">-->
            <div class="box flex">
                <div class="flex-grow">
                    <div class="handle flex-center-cross">
						<div class="title">发货信息</div>
                        <div class="inline">
                            <c-radio-group v-model="isConsignor">
                                <c-radio value="0">默认</c-radio>
                                <c-radio value="1">更改发货信息</c-radio>
                            </c-radio-group>
                        </div>
						<div v-if="isConsignor == 1" class="inline flex consignor">
							<p class="flex-center">
								<label class="flex-center"><b>*</b>发货人</label>
								<c-input v-model="consignor_name"placeholder="发货人姓名"></c-input>
							</p>
							<p class="flex-center">
								<label class="flex-center"><b>*</b>联系电话</label>
								<c-input v-model="consignor_phone" placeholder="联系电话"></c-input>
							</p>
						</div>
                    </div>
                </div>
            </div>
        </module>
        <!--订单汇总信息-->
        <module v-if="memberInfo">
            <div class="total flex-between">
                <div>
                    <p class="item">订购数量：{{productTotal.num}}件</p>
                    <p class="item">赠品数量：{{giftTotal.num}}件</p>
                </div>
                <div class="flex-column flex-center-end">
                    <div class="flex">
                        <p class="config flex-center">
                            <label><b style="color:red">*</b>配送方式</label>
                            <c-select v-model="logistics" :options="logisticsList"></c-select>
                        </p>
                        <p class="config flex-center">
                            <label>运费</label>
                            <c-input v-model="freight" type="number" decimal="2" disabled></c-input>
                        </p>
                    </div>
                    <div class="flex">
                        <p class="config remark flex">
                            <label>备注</label>
                            <textarea v-model="remark" placeholder="给订单备注请写这里"></textarea>
                        </p>
                    </div>
                    <div class="flex-baseline">
                        <p class="item">
                            商品金额 ￥{{sumTotal.product}}，
                            运费 ￥{{sumTotal.freight}}
                            <p v-if="sumTotal.points_reduce_money > 0">
                                ，积分抵扣：<span style="color: red">-￥{{sumTotal.points_reduce_money}}</span>
                            </p>
                            <p v-if="sumTotal.coupon_reduce_money > 0">
                                ，优惠券：<span style="color: red">-￥{{sumTotal.coupon_reduce_money}}</span>
                            </p>
                        </p>
                        <p class="item" style="margin-left: 20px;">应付总额：<strong>￥{{sumTotal.sum}}</strong></p>
                    </div>
                </div>
            </div>
            <template slot="button">
                <c-button size="m" @click="submitOrder()">提交订单</c-button>
            </template>
        </module>
		<member-selector ref="memberSelector" @resolve="memberHandle"></member-selector>
		<product-selector ref="productSelector" sku multiple @resolve="addProductHandle"></product-selector>
		<invoice-manage ref="invoiceManage" selector @resolve="data => currentInvoice = data"></invoice-manage>
		<address-manage ref="addressManage" selector @resolve="data => currentAddress = data"></address-manage>
		
		<c-dialog ref="import" title="导入下单商品" button-name="确认导入" width="650" @resolve="importProductHandle" @close="importFile = ''">
			<div class="import flex-column flex-center">
				<p>点击【上传文件】按钮选择文件</p>
				<p>
					<span>请您确保上传的内容符合规范，
                        <a href="https://cdn.yunchange.com/app_static/excel/%E4%BB%A3%E5%AE%A2%E6%88%B7%E5%AF%BC%E5%85%A5%E4%B8%8B%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx" target="_blank">下载模板点击这里</a></span>
				</p>
				<c-button size="m" color="gray" hollow icon="upload" @click="uploadImportHandle">上传文件</c-button>
				<div v-if="importFile" class="file flex-center"><i class="tf tf-file-xls"></i>{{importFile.fileName}}</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="payment" title="选择支付方式并下单" button-name="确认并下单" width="650" @resolve="payHandle">
			<div class="payment">
				<p>支付方式</p>
				<div class="type flex">
					<div v-for="(item, i) in payType" :key="i" class="item" :class="{'z-crt': currentPay == item}" @click="currentPay = item">{{item.name}}</div>
				</div>
				<div v-if="currentPay && currentPay.type == 'cash'" class="voucher flex-center" @click="uploadVoucherHandle">
					<img v-if="voucherImg" :src="voucherImg">
					<div v-else class="flex-center">
						<i class="tf tf-upload"></i>
						<span>上传付款凭证</span>
					</div>
				</div>
				<div v-else-if="currentPay && currentPay.type != 'cash'" class="smscode flex-column flex-center">
					<p>短信验证码将发送至客户的手机，请联系客户获取</p>
					<div class="flex-center">
						<c-input v-model="verify_code" type="number" decimal="0" height="40" placeholder="请输入短信验证码"></c-input>
						<c-button height="40" @click="getVerifyCode()">获取验证码</c-button>
					</div>
                </div>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	import memberSelector from '@/components/service/member_selector.vue'
	import productSelector from '@/components/service/product_selector.vue'
	import invoiceManage from '@/components/service/platform_user_invoice.vue'
	import addressManage from '@/components/service/platform_user_address.vue'
	import coupon from '@/components/public/coupon.vue'
    import {mapState} from "vuex";
	export default {
		name: 'm_agency_order',

		components: {
			memberSelector,
			productSelector,
			invoiceManage,
			addressManage,
			coupon
		},
		
		data() {
			return {
				memberInfo: '',
				importFile: '',
				productList: [{}],
				giftList: [{}],
				productTotal: {
					num: 0,
					sum: 0
				},
				giftTotal: {
					num: 0
				},
				logisticsList: [],
				logistics: '',
				freight: '',
				remark: '',
				
				invoiceState:0,
				currentInvoice: '',
				currentAddress: '',
				
				payType: [],
				currentPay: '',
				voucherImg: '',
                isUsePoints:1,        //是否使用积分  1=使用  0=不使用
				isUseCoupon:1,
                pointsCredit:{},      //积分抵扣信息
				currentCoupon: {
					decrease_amount: 0
				},
                userCouponList:[],   //会员拥有的优惠券集合
                isConsignor:0,       //是否代发 1=支持
                consignor_name:'',   //代发人姓名
                consignor_phone:'',   //代发人电话
                verify_code:''   //支付验证码
			}
		},

        computed: {
            ...mapState(['systemConfig']),
			
            sumTotal() {
				let freight = parseFloat(this.freight) || 0;
                var points_reduce_money = 0;//积分减免金额
                var coupon_reduce_money = this.currentCoupon.decrease_amount;//优惠券减免金额
                if (this.isUsePoints == 1 && this.pointsCredit && this.pointsCredit.points_discount_money){
                    points_reduce_money = this.pointsCredit.points_discount_money;
                }
				return {
					product: this.productTotal.sum.toFixed(2),
					freight: freight.toFixed(2),
                    points_reduce_money: points_reduce_money.toFixed(2),
                    coupon_reduce_money: coupon_reduce_money.toFixed(2),
                    sum: (this.productTotal.sum + freight - points_reduce_money - coupon_reduce_money).toFixed(2)
				};
			},
			
			memberInvoiceAddress() {
				if (!this.currentInvoice) return '';
				return (this.currentInvoice.address_province_name || '') + (this.currentInvoice.address_city_name || '') + (this.currentInvoice.address_county_name || '') + (this.currentInvoice.address_details || '');
			}
		},
		
		watch: {
			memberInfo(val) {
				this.productList = [{}];
				this.giftList = [{}];
				this.isUsePoints = 1;
				this.isUseCoupon = 1;
				this.invoiceState = 0;
				this.isConsignor = 0;
				this.consignor_name = '';
				this.consignor_phone = '';
				this.freight = '';
				this.logistics = '';
				this.remark = '';
				if (val) {
					this.getDefaultInvoice();
					this.getDefaultAddress();
					this.getReceivedCoupon();
				}
			},
			
			productList() {
				this.$nextTick(() => {
					this.updateProductTotal();
				})
			},
			
			giftList() {
				this.$nextTick(() => {
					this.updateGiftTotal();
				})
			},
			
			isUseCoupon(val) {
				if (val == 0) {
					this.currentCoupon = {
						decrease_amount: 0
					}
				}
			},

            logistics(val){
                console.log('===============================this.currentAddress=======================');
                console.log(this.currentAddress);
                console.log('===============================productTotal.num=======================');
                console.log(this.productTotal.num);
                if (val && this.currentAddress && this.productTotal.num > 0){
                    this.calLogisticsMoney();
                }
            },

            currentAddress(){
                if (this.logistics && this.productTotal.num > 0){
                    this.calLogisticsMoney();
                }
            },
		},

		mounted() {
            //加载物流公司列表
			this.request({
				url: '/logistics_company/options',
				success: data => {
					this.logisticsList = Array.from(data, item => {
						return {
							name: item.name,
							value: item.id
						}
					});
				}
			})
		},

		methods: {
			memberHandle(data) {
				this.memberInfo = data[0];
			},
			
			addProduct(type) {
				this._addType = type;
				this.$refs.productSelector.open({
                    platform_user_id: this.memberInfo.platform_user_id
				});
			},
			
			addProductHandle(data, type = this._addType) {
				data.forEach(item => {
					if (this.$refs[type].getRow(row => row.data.product_sku == item.product_sku).length > 0) {
						this.$message({
							text: '已忽略重复商品'
						});
						return;
					}
					
					this.$refs[type].push(item);
				});
				
				this.$refs[type].getRow(row => !row.data.product_sku).forEach(row => {
					row.remove();
				});
				this.$refs[type].push({});
			},
			
			uploadImportHandle() {
				this.uploadFile({
					success: data => {
						this.importFile = data;
					}
				});
			},
			
			importProductHandle(stop) {
				if (!this.importFile) {
					stop();
					this.$message({
						text: '请先上传文件'
					});
					return;
				}
				
				this.request({
					url: '/member_user/order/import',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id,
						file_url: this.importFile.filePath,
					},
					loading: true,
					success: (data, message) => {
						this.$message({
							text: message
						});
						this.productList = [{}];
						this.giftList = [{}];
						this.$nextTick(() => {
							this.addProductHandle(data.filter(item => item.is_gift == 0), 'productList');
							this.addProductHandle(data.filter(item => item.is_gift == 1), 'giftList');
						});
					}
				});
			},
			
			projectSearch(keyword, resolve, reject, param) {
				this._searchRequest && this._searchRequest.abort();
				this._searchRequest = this.request({
					url: '/product/sku/list',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id,
                        sku:'sku',
						[param]: keyword,
						pageIndex: 1,
						pageSize: 10
					},
					success: data => {
						if (data && data.length) {
							resolve(Array.from(data, item => {
								return {
									name: param == 'product_sku_code' ? item[param] : `${item[param]} - ${item.product_sku_spec}`,
									value: item[param],
									data: item
								}
							}))
						} else {
							reject('未找到相关商品，请检查搜索关键字是否正确');
						}
					}
				});
			},
			
			setProduct(option, type, row) {
				this.$nextTick(() => {
					if (this.$refs[type].getRow(item => item != row && item.data.product_sku == option.data.product_sku).length > 0) {
						this.$message({
							text: '当前商品已存在'
						});
						return;
					}
					
					this.$set(row, 'data', Object.assign(option.data, {
						count: row.data.count
					}));
					if (this.$refs[type].getRow(item => !item.data.product_sku).length == 0) {
						this.$refs[type].push({});
					}
					
					if (type == 'productList') {
						this.updateProductTotal();
					} else {
						this.updateGiftTotal();
					}
				})
			},
			
			removeProduct(item) {
				item.remove();
				this.updateProductTotal();
			},
			
			removeGift(item) {
				item.remove();
				this.updateGiftTotal();
			},
			
			updateProductTotal() {
				let num = 0, sum = 0;
				this.$refs.productList && this.$refs.productList.getRow(item => {
					if (item.data.product_sku && item.data.count) {
						num += parseInt(item.data.count) || 0;
						sum += (parseInt(item.data.count) || 0) * parseFloat(item.data.product_price)
						sum = parseFloat(sum.toFixed(2));
					}
				});
				this.productTotal = {num, sum};
                if (this.productTotal.num > 0){
                    //展示下单可用优惠券
                    this.getUserCouponByProduct();
                    //计算积分抵扣金额
                    this.getUserCreditPoints();
                    //重新计算运费
                    if (this.currentAddress && this.logistics){
                        this.calLogisticsMoney();
                    }
                }
			},
			
			updateGiftTotal() {
				let num = 0;
				this.$refs.giftList && this.$refs.giftList.getRow(item => {
					if (item.data.product_sku && item.data.count) {
						num += parseInt(item.data.count) || 0;
					}
				});
				this.giftTotal = {num};
			},
			
			getDefaultInvoice() {
				this.request({
					url: '/member_user/invoice/get/default',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id
					},
					success: data => {
						this.currentInvoice = data;
					}
				});
			},
            /**
             * 加载当前代理默认收货地址
             */
			getDefaultAddress() {
				this.request({
					url: '/member_user/address/get/default',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id
					},
					success: data => {
						this.currentAddress = data;
					}
				});
			},
            /**
             * 加载当前代理全部优惠券列表
             */
			getReceivedCoupon() {
				this.request({
					url: '/member_user/received/coupon/list',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id,
					},
					success: data => {
                        this.userCouponList = data.map(item => {
							item.not_can_reason = '未选择下单货品'
                            item.disabled  = true;
                            return item;
                        });
					}
				});
			},
            /**
             * 根据商品-加载当前代理优惠券列表（可用+不可用）
             */
			getUserCouponByProduct() {
                var skuList = [];
                this.$refs.productList.getRow().forEach(item => {
                    if (item.data.product_sku) {
                        skuList.push({
                            product_sku: item.data.product_sku,
                            count: item.data.count
                        });
                    }
                });
				this.request({
					url: '/member_user/order/coupon/list',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id,
                        sku_list:skuList
                    },
					success: data => {
                        this.userCouponList = [];
                        data.can_list.forEach(item => {
                            item.disabled = false;
                            this.userCouponList.push(item);
                        });
                        data.not_can_list.forEach(item => {
                            item.disabled = true;
                            this.userCouponList.push(item);
                        });
					}
				});
			},
            /**
             * 根据商品-计算此次下单可抵扣的积分信息
             */
			getUserCreditPoints() {
                var skuList = [];
                this.$refs.productList.getRow().forEach(item => {
                    if (item.data.product_sku) {
                        skuList.push({
                            product_sku: item.data.product_sku,
                            count: item.data.count
                        });
                    }
                });
				this.request({
					url: '/member_user/order/credit/points',
					data: {
                        platform_user_id: this.memberInfo.platform_user_id,
                        sku_list:skuList
                    },
					success: data => {
                        this.pointsCredit = data;
					}
				});
			},

			submitOrder(pay) {
				if (
					this.$refs.productList.getRow(item => item.data.product_sku && !item.data.count).length
					|| this.$refs.giftList.getRow(item => item.data.product_sku && !item.data.count).length
				) {
					this.$message({
						text: '请填写已选货品数量'
					});
					return;
				}
				
				var skuList = [];
				var giftSkuList = [];
				this.$refs.productList.getRow().forEach(item => {
					if (item.data.product_sku) {
						skuList.push({
							product_sku: item.data.product_sku,
							count: item.data.count,
							is_gift: 0
						});
					}
				});
				this.$refs.giftList.getRow().forEach(item => {
					if (item.data.product_sku) {
                        giftSkuList.push({
							product_sku: item.data.product_sku,
							count: item.data.count,
							is_gift: 1
						});
					}
				});
				
				if (!skuList.length) {
					this.$message({
						text: '请选择要购买的货品'
					});
					return;
				}

				if (!this.logistics) {
					this.$message({
						text: '请选择配送方式'
					});
					return;
				}
				
				if (!this.freight) {
					this.$message({
						text: '请输入运费'
					});
					return;
				}
				
				if (this.invoiceState == 1 && !this.currentInvoice) {
					this.$message({
						text: '请选择发票信息'
					});
					return;
				}
				
				if (!this.currentAddress) {
					this.$message({
						text: '请选择收货地址'
					});
					return;
				}
                if (pay) {
                    this.request({
						url: '/member_user/order/submit',
						data: {
                            platform_user_id: this.memberInfo.platform_user_id,
							product_money: parseFloat(this.sumTotal.product),
							logistics_money: parseFloat(this.sumTotal.freight),
                            sku_list: skuList,
                            gift_sku_list: giftSkuList,
							logistics_company_id: this.logistics,
							order_remark: this.remark,
							invoice_id: this.invoiceState == 1 ? this.currentInvoice.id : '',
							address_id: this.currentAddress.id,
							pay_type: this.currentPay.type,
                            verify_code:this.verify_code,
                            pay_voucher_url: this.voucherImg,
                            points:(this.memberInfo.points>0 && this.isUsePoints==1)?this.pointsCredit.points:0,
                            points_discount_money:(this.memberInfo.points>0 && this.isUsePoints==1)?this.pointsCredit.points_discount_money:0,
                            coupon_id: this.currentCoupon.id,
                            coupon_discount_money: this.currentCoupon.decrease_amount,
                            consignor_name:this.consignor_name,
                            consignor_phone:this.consignor_phone
						},
						loading: true,
						success: data => {
							this.$refs.payment.close();
                            this.$confirm({
                                text: '已成功下单【'+data+'】',
                                buttonName: '知道了',  // 确定按钮文字
                                cancelButton: false,  // 是否显示取消按钮
                                resolve: () => {
                                    this.memberInfo = '';
                                }
                            });
						}
					});
				} else {
					this.request({
						url: '/member_user/order/confirm',
						data: {
                            platform_user_id: this.memberInfo.platform_user_id,
							product_money: parseFloat(this.sumTotal.product),
							logistics_money: parseFloat(this.sumTotal.freight),
							sku_list: skuList
						},
						loading: true,
						success: data => {
                            //查询支付方式
                            this.request({
                                url: '/member_user/pay_channel_list',
                                data: {
                                    platform_user_id: this.memberInfo.platform_user_id,
                                    pay_money: parseFloat(this.sumTotal.sum)
                                },
                                loading: true,
                                success: data => {
                                    //查询支付方式
                                    this.payType = data;
                                    this.currentPay = this.payType[0];
                                    this.$refs.payment.open();
                                }
                            });
						}
					});
				}
			},
			
			uploadVoucherHandle() {
				this.uploadFile({
					fileType: 'image',
					success: data => {
						this.voucherImg = data.filePath;
					}
				});
			},
			
			payHandle(stop) {
				stop();
				if (this.currentPay.pay_type == 'cash' && !this.voucherImg) {
					this.$message({
						text: '请上传付款凭证'
					});
					return;
				}
				this.submitOrder(true);
			},

            //根据下单商品-计算运费
            calLogisticsMoney(){
                var skuList = [];
                this.$refs.productList.getRow().forEach(item => {
                    if (item.data.product_sku) {
                        skuList.push({
                            product_sku: item.data.product_sku,
                            count: item.data.count,
                            is_gift: 0
                        });
                    }
                });
                this.request({
                    url: '/member_user/order/freight/money',
                    data: {
                        platform_user_id: this.memberInfo.platform_user_id,
                        logistics_company_id: this.logistics,
                        province_id: this.currentAddress.receiving_address_province_id,
                        sku_list: skuList
                    },
                    loading: true,
                    success: data => {
                        this.freight = data||0;
                    }
                });
            },

            //获取支付验证码
            getVerifyCode(){
                this.request({
                    url: '/member_user/pay/verify/code',
                    data: {
                        platform_user_id: this.memberInfo.platform_user_id
                    },
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '支付验证码已发送至手机'+data+'请注意查收',
                            icon: 'success'
                        });
                    }
                });
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.order-submit {
		.box {
			padding: 24px 32px;
		}
		
		.c-select {
			height: 28px;
		}
	}
	
	.client-info {
		height: 90px;
		padding: 0 26px 0 16px;
		margin-bottom: 10px;
		background: #FAFAFA;
		
		.icon {
			width: 44px;
			height: 44px;
			border-radius: 100%;
			margin-right: 14px;
			font-size: 22px;
			color: #fff;
			theme-background(main);
		}
		
		.name {
			font-size: 18px;
			font-weight: bold;
		}
		
		.code {
			margin-top: 10px;
			font-size: 13px;
			color: #666;
		}
	}
	
	.client-empty {
		padding-top: 250px;
		text-align: center;
		color: #ccc;
		
		div {
			font-size: 66px;
		}
		
		p {
			margin-top: 10px;
			font-size: 16px;
		}
	}
	
	.handle {
		height: 54px;
		
		.title {
			min-width: 4em;
			border-left: 3px solid #000;
			padding-left: 7px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		.tip {
			margin-left: 15px;
			font-size: 13px;
			color: #999;
			
			span {
				color: #f00;
			}
		}
		
		.inline {
			margin-left: 15px;
		}
		
		>>> .c-button {
			margin-left: 13px;
		}
	}
	
	.c-table {
		margin-bottom: 10px;
	}
	
	.total {
		box-sizing: border-box;
		padding: 20px;
		font-size: 13px;
		
		.item {
			line-height: 30px;
			
			strong {
				font-size: 16px;
				font-weight: bold;
				color: #C70000;
			}
		}
		
		.config {
			margin-left: 20px;
			margin-bottom: 10px;
		
			&.tip {
				color: #f55;
			}
			
			label {
				width: 5em;
				line-height: 30px;
				margin-right: .5em;
				white-space: nowrap;
				text-align: right;
				
				b {
					margin-right: .5em;
				}
			}
			
			>>> .c-datetime {
				width: 140px;
				
				.el-date-editor {
					.el-input__inner {
						height: 30px;
					}
					
					.el-input__icon {
						line-height: 30px;
					}
				}
			}
			
			>>> .c-select {
				width: 122px;
			}
			
			>>> .c-input {
				width: 140px;
			}
			
			>>> .c-file-button {
				height: auto;
			}
			
			textarea {
				box-sizing: border-box;
				width: 371px;
				height 100px;
				border: 1px solid #ddd;
				padding: 4px 10px;
				line-height: 18px;
				resize: none;
			}
		}
	}
	
	.other {
		padding: 12px 24px;
		background: #FAFAFA;
		
		.empty {
			height: 177px;
			font-size: 16px;
			text-align: center;
			color: #f55;
		}
		
		.content {
		}
		
		.item {
			padding: 8px 0;
			line-height: 16px;
			font-size: 13px;
			
			label {
				color: #666;
			}
		}
		
		a {
			font-size: 13px;
			color: #00A8E3;
			
			.tf {
				margin-right: .5em;
			}
		}
	}
	
	.import {
		height: 310px;
		
		p {
			margin-bottom: 18px;
			font-size: 15px;
			font-weight: bold;
			
			span {
				font-size: 13px;
				font-weight: normal;
				color: #999;
				
				a {
					color: #00A8E3;
				}
			}
		}
		
		.file {
			margin-top: 26px;
			font-size: 13px;
			color: #333;
			
			.tf {
				margin-right: 8px;
				font-size: 18px;
			}
		}
	}
	
	.coupon-list {
		margin-left: 89px;
		gap: 10px;
	}
	
	.consignor {
		p {
			margin-left: 20px;
		
			label {
				margin-right: 10px;
				
				b {
					width: 1em;
					color: #f00;
				}
			}
		}
	}
	
	.payment {
		box-sizing: border-box;
		height: 400px;
		padding: 25px 30px 0;
		
		p {
			margin-bottom: 14px;
			font-size: 15px;
			color: #444;
		}
		
		.type {
			.item {
				box-sizing: border-box;
				width: 180px;
				border: 1px solid #ddd;
				margin-right: 16px;
				line-height: 60px;
				font-size: 22px;
				text-align: center;
				color: #666;
				cursor: pointer;
				
				&:hover,
				&.z-crt {
					border-color: #23B158;
					color: #23B158;
				}
				
				&.z-crt {
					position: relative;
					background: #F2FFF7;
					
					&:after {
						content: '';
						position: absolute;
						right: 0;
						bottom: 0;
						width: 24px;
						height: 18px;
						background-image: url('~@/assets/image/z_crt.png');
						background-size: 100% 100%;
					}
				}
			}
		}
		
		.voucher {
			height: 228px;
			margin-top: 15px;
			background: #F9F9F9;
			font-size: 20px;
			color: #aaa;
			cursor: pointer;
			
			.tf {
				margin-right: 5px;
				font-size: 28px;
			}
		}
		
		.smscode {
			height: 228px;
			margin-top: 15px;
			background: #F9F9F9;
			color: #aaa;
			
			p {
				font-size: 13px;
				color: #666;
			}
		}
	}
</style>